import { render } from "./ChooseLang.vue?vue&type=template&id=ebcde458&scoped=true"
import script from "./ChooseLang.vue?vue&type=script&lang=js"
export * from "./ChooseLang.vue?vue&type=script&lang=js"

import "./ChooseLang.vue?vue&type=style&index=0&id=ebcde458&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebcde458"]])

export default __exports__